import { Card, Title, Text, Flex, Skeleton, Box } from '@mantine/core'
import { differenceInDays } from 'date-fns'

import { useTranslation } from '@flecto/translations'
import { type CoreUserSubscription } from '@flecto/types'
import { Badge } from '@flecto/ui'
import { formatDateString } from '@flecto/utils'

type NextBillingProps = {
  subscription?: CoreUserSubscription
  isLoading?: boolean
}

export function NextBilling({ subscription, isLoading }: NextBillingProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_billing' })

  const isStarter = subscription?.plan === 'Starter'

  return (
    <Card withBorder w='100%'>
      <Title order={5} mb='xs' mt='sm'>
        {t('title_next_billing')}
      </Title>

      <Text c='gray.7' size='sm' mb='md'>
        {t('description_next_billing')}
      </Text>

      <Flex w='100%' justify='space-between' mb='sm'>
        {isStarter ? (
          <Badge color='gray'>
            <Text c='gray.8' fw={500}>
              {t('badge_starter')}
            </Text>
          </Badge>
        ) : isLoading ? (
          <Skeleton h='24px' w='100px' />
        ) : subscription?.next_billing_at ? (
          <Flex wrap='wrap' gap='sm' align='baseline'>
            <Text>
              {t('renews_on_next_billing', {
                replace: {
                  date: formatDateString({
                    date: subscription?.next_billing_at ?? '',
                    variant: 'date-full',
                  }),
                },
              })}
            </Text>

            <Badge color='gray' size='sm'>
              <Text size='xs' c='gray.9' fw={500}>
                {t('badge_next_billing', {
                  replace: {
                    days: differenceInDays(
                      new Date(subscription?.next_billing_at ?? ''),
                      new Date()
                    ),
                  },
                })}
              </Text>
            </Badge>
          </Flex>
        ) : (
          <Box />
        )}

        {/* TODO: add next billing values after product team decides */}
        {/* <Flex direction='column' align='flex-end' mx='sm' wrap='nowrap'>
          <Flex align='center' gap='xs'>
            {isStarter ? (
              <TextCurrency fw={500} size='lg' cents={0} />
            ) : (
              <>
                <TextCurrency
                  fw={500}
                  size='lg'
                  cents={subscription?.billing_amount_cents ?? 0}
                />
                <Text c='gray.7'>/{subscription?.billing_period ?? ''}</Text>
              </>
            )}
          </Flex>
          {subscription?.current_period_estimate?.insurance_cents !== 0 && (
            <Tooltip label={t('tooltip_next_billing')} position='top'>
              <Text size='sm' td='underline'>
                {t('info_next_billing')}{' '}
              </Text>
            </Tooltip>
          )}
        </Flex> */}
      </Flex>
    </Card>
  )
}
